export const createFormWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

export const createHeaderFieldsStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const createLinesWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const createLineRowStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '12px',
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.divider}`,
};

export const createLineHeaderStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const createLineFieldsStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const addLineButtonWrapperStyles = {
  display: 'flex',
};
